define("CCAW.FloatingContactUs.EntryPoint", [
    "CCAW.FloatingContactUs.Button.View",
], function (CCAWFloatingContactUsButtonView) {
    "use strict";

    var LOCAL_TEST_DEFAULTS = {
        desktopImageUrl: "/extensions/CCAW/CCAWFloatingContactUs/1.0.0/img/desktop.png",
        mobileImageUrl: "/extensions/CCAW/CCAWFloatingContactUs/1.0.0/img/mobile.png",
        buttonAltText: "Contact Us",
        modalTitle: "",
        jotformScriptUrl: "https://form.jotform.com/jsform/262073969595272",
    };

    function getConfig(container, key) {
        var environment = container.getComponent("Environment");

        if (!environment) {
            return null;
        }

        return environment.getConfig("CCAWFloatingContactUs." + key);
    }

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent("Layout");

            if (!layout || getConfig(container, "enabled") === false) {
                return;
            }

            layout.addChildView("CCAW.FloatingContactUs", function () {
                return new CCAWFloatingContactUsButtonView({
                    container: container,
                    config: {
                        desktopImageUrl:
                            getConfig(container, "desktopImageUrl") ||
                            LOCAL_TEST_DEFAULTS.desktopImageUrl,
                        mobileImageUrl:
                            getConfig(container, "mobileImageUrl") ||
                            LOCAL_TEST_DEFAULTS.mobileImageUrl,
                        buttonAltText:
                            getConfig(container, "buttonAltText") ||
                            LOCAL_TEST_DEFAULTS.buttonAltText,
                        modalTitle:
                            getConfig(container, "modalTitle") ||
                            LOCAL_TEST_DEFAULTS.modalTitle,
                        jotformScriptUrl:
                            getConfig(container, "jotformScriptUrl") ||
                            LOCAL_TEST_DEFAULTS.jotformScriptUrl,
                    },
                });
            });
        },
    };
});
